<div class="row">
  <div class="rs-auto">
    <p class="rs-strength-text rs-padding-bottom1" data-max="7" data-value="2">
      <i class="icon-Error-box icon-large icon-lh"></i>
    </p>
  </div>
  <div class="rs-last rs-no-padding-left" *ngIf="errors.required">
    <p class="rs-strength-text rs-padding-bottom1" data-max="7" data-value="2">
      {{ 'email.validation.required.error' | translate }}
    </p>
  </div>
  <div class="rs-last rs-no-padding-left" *ngIf="errors.pattern">
    <p class="rs-strength-text rs-padding-bottom1" data-max="7" data-value="2">
      {{ 'email.validation.pattern.error' | translate }}
    </p>
  </div>
  <div class="rs-last rs-no-padding-left" *ngIf="errors.forbiddenValues">
    <p class="rs-strength-text rs-padding-bottom1" data-max="7" data-value="2">
      {{ 'email.validation.forbidden.error' | translate }}
    </p>
  </div>
</div>
